module.exports = __webpack_public_path__ + "img/resources4.fcfccf0e.jpg";